import { createI18n } from "vue-i18n";
import { de, en, type MessageSchema } from "../locales";

export const locales = ["de", "en"];

type SupportedLocale = (typeof locales)[number];

declare module "vue-i18n" {
  // export interface DefineLocaleMessage extends MessageSchema {}
}

export default defineNuxtPlugin(({ vueApp }) => {
  const locale = useCookie("locale");

  const i18n = createI18n<{ messages: MessageSchema }, SupportedLocale>({
    locale: locale.value ?? "de",
    fallbackLocale: "en",
    globalInjection: true,
    messages: {
      de,
      en
    }
  });

  vueApp.use(i18n);
});
